import React from 'react';
import styles from './PaymentInfoItem.module.scss';

/* Interfaces */
import { PaymentTypesReversed } from '../../interfaces/payment_types';

/* Components */
import StripeInfo from './Stripe/StripeInfo';
import { PaypalInfo } from './Paypal/PaypalInfo';
import { PixInfo } from './PIX/PixInfo';

/* Providers */
import { usePaymentTypeContext } from '../../__providers__/PaymentTypeContext';

interface PaymentInfoItemProps {}

export const PaymentInfoItem: React.FC<PaymentInfoItemProps> = () => {
  const { selectedPayment } = usePaymentTypeContext();

  return (
    <div className={styles.container}>
      {selectedPayment === PaymentTypesReversed.Stripe && <StripeInfo />}
      {selectedPayment === PaymentTypesReversed.Paypal && <PaypalInfo />}
      {selectedPayment === PaymentTypesReversed.Pix && <PixInfo />}
    </div>
  );
};
